var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHistory = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46314 4.45533C7.49941 1.42334 12.4351 1.45558 15.49 4.51042C18.5461 7.56657 18.5771 12.5052 15.5411 15.5412C12.5052 18.5771 7.56654 18.5461 4.51039 15.49C2.6993 13.6789 1.95143 11.2081 2.27257 8.86518C2.31757 8.53688 2.62019 8.30721 2.94849 8.35221C3.27679 8.39721 3.50646 8.69983 3.46146 9.02814C3.18948 11.0124 3.82245 13.105 5.35891 14.6415C7.9545 17.237 12.1333 17.2519 14.6926 14.6926C17.2519 12.1333 17.237 7.95453 14.6414 5.35894C12.0472 2.76469 7.8713 2.74851 5.31167 5.30385L5.90984 5.30686C6.2412 5.30852 6.50848 5.5785 6.50681 5.90987C6.50515 6.24123 6.23517 6.50851 5.9038 6.50684L3.86736 6.49661C3.53835 6.49496 3.27204 6.22865 3.27039 5.89963L3.26015 3.86319C3.25849 3.53182 3.52576 3.26185 3.85713 3.26018C4.1885 3.25852 4.45847 3.52579 4.46014 3.85716L4.46314 4.45533ZM10.0001 6.20013C10.3315 6.20013 10.6001 6.46876 10.6001 6.80013V9.7516L12.4244 11.5759C12.6587 11.8102 12.6587 12.1901 12.4244 12.4244C12.1901 12.6587 11.8102 12.6587 11.5758 12.4244L9.4001 10.2487V6.80013C9.4001 6.46876 9.66873 6.20013 10.0001 6.20013Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHistory, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/History.dbd6af64.svg";
export { ForwardRef as ReactComponent };